document.addEventListener("DOMContentLoaded", () => {
  const OFFSET = 100;

  // Scroll helper
  function scrollToAnchor(id) {
    const targetEl = document.getElementById(id);
    if (!targetEl) return;

    const y = targetEl.getBoundingClientRect().top + window.scrollY - OFFSET;
    window.scrollTo({ top: y, behavior: "smooth" });
  }

  // Handle all clicks on <a> (delegated)
  document.addEventListener("click", (e) => {
    const link = e.target.closest("a");
    if (!link) return;

    // Parse link href
    let href;
    try {
      href = new URL(link.href);
    } catch {
      return; // invalid href
    }

    const samePage = href.pathname === window.location.pathname;
    const hash = href.hash?.substring(1);

    // Only intercept same-page links with a hash
    if (samePage && hash) {
      e.preventDefault();
      scrollToAnchor(hash);

      // Update hash in address bar (without jump)
      history.pushState(null, "", `#${hash}`);
    }
  });

  // On initial load (with hash in URL)
  if (window.location.hash) {
    const id = window.location.hash.substring(1);
    window.addEventListener("load", () => {
      scrollToAnchor(id);
    });
  }
});

function showModal({
  title = "Notice",
  message = "",
  confirmText = "OK",
  cancelText = null,
  confirmClass = "btn-primary",
  cancelClass = "btn-secondary",
  onConfirm = null,
  onCancel = null
} = {}) {
  document.querySelector(".modal-global")?.remove();

  const modal = document.createElement("div");
  modal.className = "modal-global";
  modal.innerHTML = `
    <div class="modal-overlay"></div>
    <div class="modal-content">
      <h3>${title}</h3>
      <p>${message}</p>
      <div class="modal-buttons">
        ${cancelText ? `<button class="btn btn-sm btn-cancel ${cancelClass}">${cancelText}</button>` : ""}
        <button class="btn btn-sm btn-confirm ${confirmClass}">${confirmText}</button>
      </div>
    </div>
  `;
  document.body.appendChild(modal);

  const overlay  = modal.querySelector(".modal-overlay");
  const confirm  = modal.querySelector(".btn-confirm");
  const cancel   = modal.querySelector(".btn-cancel");

  const close = () => modal.remove();

  overlay.addEventListener("click", close);

  if (cancel) {
    cancel.addEventListener("click", () => {
      close();
      if (typeof onCancel === "function") onCancel();
    });
  }

  if (confirm) {
    confirm.addEventListener("click", () => {
      close();
      if (typeof onConfirm === "function") onConfirm();
    });
  }
}